// @ts-nocheck
import { supabase } from "@/integrations/supabase/client";

/**
 * Returns a stable per-visitor session id, persisted in sessionStorage.
 * Used to de-duplicate sponsor impressions/clicks per browsing session.
 */
export function getSponsorSessionId(): string {
  const KEY = "rl_sponsor_session_id";
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id =
        (typeof crypto !== "undefined" && crypto.randomUUID)
          ? crypto.randomUUID()
          : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // sessionStorage unavailable (SSR / privacy mode): fall back to ephemeral id
    return `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }
}

export type SponsorPlacement = "event_page" | "registration" | "confirmation";

export async function trackSponsorImpression(
  sponsorId: string,
  placement: SponsorPlacement,
  eventId?: string | null
) {
  if (!sponsorId) return;
  try {
    await supabase.rpc("track_sponsor_event", {
      p_sponsor_id: sponsorId,
      p_kind: "impression",
      p_event_id: eventId ?? null,
      p_placement: placement,
      p_session_id: getSponsorSessionId(),
    });
  } catch (err) {
    // Analytics must never break the page
    console.warn("[sponsorTracking] impression failed", err);
  }
}

export async function trackSponsorClick(
  sponsorId: string,
  placement: SponsorPlacement,
  targetUrl?: string | null,
  eventId?: string | null
) {
  if (!sponsorId) return;
  try {
    await supabase.rpc("track_sponsor_event", {
      p_sponsor_id: sponsorId,
      p_kind: "click",
      p_event_id: eventId ?? null,
      p_placement: placement,
      p_target_url: targetUrl ?? null,
      p_session_id: getSponsorSessionId(),
    });
  } catch (err) {
    console.warn("[sponsorTracking] click failed", err);
  }
}
